import * as React from 'react'

export interface FileUploadContext {
  id?: string
  inProgress?: boolean
  name?: string
  progress?: number
  size: 'sm' | 'md'
  value?: string
  setValue: (value: File) => void
}

export const FileUploadContext = React.createContext<FileUploadContext | null>(null)

export function useFileUploadContext() {
  const context = React.useContext(FileUploadContext)
  if (!context) {
    throw new Error('useFileUploadContext must be used within <FileUploadRoot>')
  }
  return context
}
